import React, { createContext, useEffect, useState, useRef } from 'react';
import { ApiService } from './services/apiServices';

const DataContext = createContext();
export const DataProvider = ({ children }) => {
  const [settingImageBaseUrl, setSettingImageBaseUrl] = useState('');
  const [catImageBaseUrl, setcatImageBaseUrl] = useState('');
  const [orderRecieveStatus, setorderRecieveStatus] = useState(() => {
    return localStorage.getItem('OrderRecieveStatus') || 'delivery';
  });
  const [menuSchedule, setMenuSchedule] = useState(() => {
    return localStorage.getItem('menuSchedule') || 'lunch';
  });

  const [lunchDayTimeStatus, setLunchDayTimeStatus] = useState(false)
  const [dinnerDayTimeStatus, setDinnerDayTimeStatus] = useState(false)

  const [settingData, setSettingData] = useState({});
  const [UserToken, setUserToken] = useState(localStorage.getItem('USER_TOKEN'));
  const [featuredCategories, setfeaturedCategories] = useState({});
  const [selectedProduct, setSelectedProduct] = useState({});
  const [toggleLoginsModal, setToggleLoginModal] = useState(false)
  const [toggleLocationModal, setToggleLocationModal] = useState(false)
  const [toggleItemAddModal, setToggleItemAddModal] = useState(false)
  const [toggleCateringModal, setToggleCateringModal] = useState(false)
  const [toggleTimeSlotModal, setToggleTimeSlotModal] = useState(false);

  const [toggleDeliveryTimeSlotModal, setToggleDeliveryTimeSlotModal] = useState(false);
  const [cartItemDeliverySlot, setCartItemDeliverySlot] = useState({});

  const [loadingItemId, setLoadingItemId] = useState('')
  const [toggleMobilesMenuModal, setToggleMobilesMenuModal] = useState(false)
  const [isStoreLoader, setIsStoreLoader] = useState(true)
  const [togglechangeStoreModal, setToggleChangeStoreModal] = useState(false)
  const [cartSessionData, setCartSessionData] = useState([]);
  const [addonProduct, setaddonProductProduct] = useState([]);
  const [rowUserData, setRowUserData] = useState({});
  const [cartCount, setCartCount] = useState(0);
  const [selectedDateTime, setSelectedDateTime] = useState(null);
  const [toggleapplycoupanModal, setToggleApplyCoupanModal] = useState(false)
  const [selectedCoupon, setSelectedCoupon] = useState({
    discount_amount: 0.00,
    promo_id: 0,
    promo_code: '',
  });
  const [addressList, setAddressList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [toggleAddressListModal, setToggleAddressListModal] = useState(false);
  const [toggleAddressModal, setToggleAddressModal] = useState(false)
  const [toggleCartMenuItems, setCartMenuItemsModal] = useState(false)
  const [toggleCartMenu, setCartMenuItems] = useState([])
  const [userAddressDetails, setUserAddressDetails] = useState({
    ua_id: 0,
    ua_name: "",
    ua_email: "",
    ua_mobile: "",
    ua_state_name: "",
    ua_city_name: "",
    ua_address_type: "Home",
    ua_address_type_other: "",
    ua_house_no: "",
    ua_pincode: "",
    ua_suburb:"",
    ua_suburb_id:0,
    ua_user_id: 0,
    ua_default_address: "",
    ua_floor: '',
    ua_country_id: 13,
    ua_country_name: "Australia",
    ua_latitude: "",
    ua_longitude: "",
    ua_complete_address: "",
    ua_how_to_reach: "",
  });
  const [storesData, setStoresData] = useState([]);
  const [selectedStore, setselectedStore] = useState({});

  const [toggleWalletModal, setToggleWalletModal] = useState(false)
  const [UserData, setUserData] = useState({});
  const didMountRef = useRef(true);

  const [selectedCateringMenu, setSelectedCateringMenu] = useState({});
  const [toggleCateringMenuModal, setToggleCateringMenuModal] = useState(false)
  useEffect(() => {
    if (didMountRef.current) {
      if (localStorage.getItem('CART_SESSION')) {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || [];
        setCartSessionData(cart);
        setCartCount(cart.length);
      }
      getSettingData()
      getStores()
      if (localStorage.getItem('USER_TOKEN')) {
        getUserData()
      }
    }
    didMountRef.current = false;
  }, [])
  const getSettingData = () => {
    try {
      ApiService.fetchData('/setting-data').then((res) => {
        if (res.status === 'success') {
          setSettingData(res.data)
          setSettingImageBaseUrl(res.setting_img_path)
        }
      })
    } catch (error) {
      console.error('An error occurred while fetching blog data:', error);
    }
  }
  const getUserData = () => {
    try {
      ApiService.fetchData("profile-data").then((res) => {
        if (res?.status === "success") {
          setUserData(res?.userData);
        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          window.location.href = '/'
        }
      });
    } catch (error) {
      console.error('An error occurred while fetching blog data:', error);
    }
  }
  const getStores = () => {

    ApiService.fetchData('getourstoredata').then((res) => {
      if (res.status === 'success') {
        if (res.resStoreData.length > 0) {
          setStoresData(res.resStoreData);
          const selectedstore = JSON.parse(localStorage.getItem('selectedStore'));
          if (selectedstore) {
            const isStoreExist = res.resStoreData.some(
              (store) => store.store_id === selectedstore.store_id
            );
            if (isStoreExist) {
              setselectedStore(selectedstore);
            } else {
              localStorage.removeItem('selectedStore');
              setselectedStore(res.resStoreData[0]);
              localStorage.setItem('selectedStore', JSON.stringify(res.resStoreData[0]));
            }
          } else {
            setselectedStore(res.resStoreData[0]);
            localStorage.setItem('selectedStore', JSON.stringify(res.resStoreData[0]));
          }
          setIsStoreLoader(false)
        } else {
          localStorage.removeItem('selectedStore');
          setIsStoreLoader(false)
        }
      }
    }).catch(() => {
      setIsStoreLoader(false)
      console.error('Error fetching store data.');
    });
  };

  return (
    <DataContext.Provider value={
      {
        settingData, setSettingData,
        settingImageBaseUrl, setSettingImageBaseUrl,
        toggleLoginsModal, setToggleLoginModal,
        toggleMobilesMenuModal, setToggleMobilesMenuModal,
        toggleItemAddModal, setToggleItemAddModal,

        toggleCateringModal, setToggleCateringModal,
        selectedProduct, setSelectedProduct,
        featuredCategories, setfeaturedCategories,
        catImageBaseUrl, setcatImageBaseUrl,
        toggleapplycoupanModal, setToggleApplyCoupanModal,
        cartSessionData, setCartSessionData,
        cartCount, setCartCount,
        rowUserData, setRowUserData,
        UserToken, setUserToken,
        orderRecieveStatus, setorderRecieveStatus,
        loadingItemId, setLoadingItemId,
        menuSchedule, setMenuSchedule,

        selectedDateTime, setSelectedDateTime,

        toggleTimeSlotModal, setToggleTimeSlotModal,

        storesData, setStoresData,
        selectedStore, setselectedStore,
        togglechangeStoreModal, setToggleChangeStoreModal,
        addonProduct, setaddonProductProduct,
        lunchDayTimeStatus, setLunchDayTimeStatus,
        dinnerDayTimeStatus, setDinnerDayTimeStatus,

        selectedCoupon, setSelectedCoupon,

        addressList, setAddressList,
        toggleAddressModal, setToggleAddressModal,
        userAddressDetails, setUserAddressDetails,
        selectedAddress, setSelectedAddress,
        toggleAddressListModal, setToggleAddressListModal,

        isStoreLoader, setIsStoreLoader,
        toggleWalletModal, setToggleWalletModal,
        toggleDeliveryTimeSlotModal, setToggleDeliveryTimeSlotModal,
        cartItemDeliverySlot, setCartItemDeliverySlot,

        toggleCartMenuItems, setCartMenuItemsModal,
        toggleCartMenu, setCartMenuItems,
        UserData, setUserData,
        toggleLocationModal, setToggleLocationModal,

        selectedCateringMenu, setSelectedCateringMenu,
        toggleCateringMenuModal, setToggleCateringMenuModal

      }
    }>
      {children}
    </DataContext.Provider>
  );
};

export default DataContext;